export var PetsStatus;
(function (PetsStatus) {
    PetsStatus[PetsStatus["Initial"] = 0] = "Initial";
    PetsStatus[PetsStatus["Clean"] = 1] = "Clean";
    PetsStatus[PetsStatus["Fetching"] = 2] = "Fetching";
    PetsStatus[PetsStatus["FetchSuccess"] = 3] = "FetchSuccess";
    PetsStatus[PetsStatus["Getting"] = 4] = "Getting";
    PetsStatus[PetsStatus["GetSuccess"] = 5] = "GetSuccess";
    PetsStatus[PetsStatus["SavingMedicalHistory"] = 6] = "SavingMedicalHistory";
    PetsStatus[PetsStatus["SaveMedicalHistorySuccess"] = 7] = "SaveMedicalHistorySuccess";
    PetsStatus[PetsStatus["SavingVetId"] = 8] = "SavingVetId";
    PetsStatus[PetsStatus["SaveVetIdSuccess"] = 9] = "SaveVetIdSuccess";
    PetsStatus[PetsStatus["SavingPet"] = 10] = "SavingPet";
    PetsStatus[PetsStatus["SavePetSuccess"] = 11] = "SavePetSuccess";
    PetsStatus[PetsStatus["SavingImage"] = 12] = "SavingImage";
    PetsStatus[PetsStatus["SaveImageSuccess"] = 13] = "SaveImageSuccess";
    PetsStatus[PetsStatus["Deleting"] = 14] = "Deleting";
    PetsStatus[PetsStatus["DeleteSuccess"] = 15] = "DeleteSuccess";
    PetsStatus[PetsStatus["PostingNote"] = 16] = "PostingNote";
    PetsStatus[PetsStatus["PostNoteSuccess"] = 17] = "PostNoteSuccess";
    PetsStatus[PetsStatus["SavingVaccine"] = 18] = "SavingVaccine";
    PetsStatus[PetsStatus["SaveVaccineSuccess"] = 19] = "SaveVaccineSuccess";
    PetsStatus[PetsStatus["DeletingVaccine"] = 20] = "DeletingVaccine";
    PetsStatus[PetsStatus["DeleteVaccineSuccess"] = 21] = "DeleteVaccineSuccess";
    PetsStatus[PetsStatus["DeletingMedicalCondition"] = 22] = "DeletingMedicalCondition";
    PetsStatus[PetsStatus["DeleteMedicalConditionSuccess"] = 23] = "DeleteMedicalConditionSuccess";
    PetsStatus[PetsStatus["ActivatingPet"] = 24] = "ActivatingPet";
    PetsStatus[PetsStatus["ActivatePetSuccess"] = 25] = "ActivatePetSuccess";
    PetsStatus[PetsStatus["MarkingAsDeceasedPet"] = 26] = "MarkingAsDeceasedPet";
    PetsStatus[PetsStatus["MarkAsDeceasedSuccess"] = 27] = "MarkAsDeceasedSuccess";
    PetsStatus[PetsStatus["PrintingPetCardPDF"] = 28] = "PrintingPetCardPDF";
    PetsStatus[PetsStatus["PrintPetCardPDFSuccess"] = 29] = "PrintPetCardPDFSuccess";
    PetsStatus[PetsStatus["Error"] = 30] = "Error";
})(PetsStatus || (PetsStatus = {}));
